module.exports = __webpack_public_path__ + "img/cw.e66bb2f4.svg";